import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class ComponentQuality extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);


		this.state = {
			start_date 	: "",
			end_date 	: "",
			component_type:"",
			components:[],
			blood_component_id:"",
            blood_components:[],
            folio_inicial:"",
            folio_final:"",
			destination:"all",
			destinations:[],
			type:"date",
			listado:[],
			columns:[
				{title:'Unidad'},
				{title:'Volumen'},
				{title:'Peso'},
			],
			filename:"Calidad de Componentes",
			health_facilities_id:"",
			component_name:"",
			blood_component_name:"",
			
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}


	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({components:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component/by_type?type='+this.state.component_type, {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({blood_components:response});
			}
		})
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas+'\t\t\t'+this.state.medical, margin:[10,0,0,10] });
						doc.content.splice(3, 0, {
							columns:[
								this.state.component_type !== "all" && this.state.component_type !== "" ?
									{text: 'Tipo Componente', width:'10%', fontSize:6.5}
								: {text:"", width:0},
								this.state.component_type !== "all" && this.state.component_type !== "" ?
									{text: this.state.component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.blood_component_id !== "all" && this.state.blood_component_id !== "" ?
									{text: 'Componente', width:'8%', fontSize:6.5}
								: {text:"", width:0},
								this.state.blood_component_id !== "all" && this.state.blood_component_id !== "" ?
									{text: this.state.blood_component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},
							]
                        });
                        
                        var width = ["15%","15%","10%"];
                        
                        var n = 60 / (this.state.columns.length - 3);
                        this.state.columns.map((c)=>{
                            if(c.id !== undefined){
                                width.push(n+'%');        
                            }
                        });
                                                
                        doc.content[4].table.widths = width;
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'component_type'){
			if(e.target.value === 'all'){
				this.setState({blood_component_id:'all'});
			}else{
				this.setState({
					component_name: e.target.options[e.target.selectedIndex].text
				});
				setTimeout(()=>{
					this.getBloodComponent();
				}, 500);
				
			}
		}else if(e.target.name === 'blood_component_id'){
			this.setState({
				blood_component_name: e.target.options[e.target.selectedIndex].text
			})
		}

	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
                    health_facilities_id:sessionStorage.getItem('health_facilities_id'),
                    blood_component_id: this.state.blood_component_id,
                    option:this.state.type,
                    start_date:this.state.start_date,
                    end_date:this.state.end_date,
                    start_folio:this.state.folio_inicial,
					end_folio:this.state.folio_final,
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/quality_control',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){

						this.setState({
							listado: [],
						});
                        
                        var columns = [
                            {title:'Unidad'},
                            {title:'Volumen'},
                            {title:'Peso'},
                        ];

						var list = [];

                        response.quality_fields.map((q)=>
                            columns.push({title:q.field_label, id:q.id})
                        );

                        response.resp.map((r, i)=>{
                           var obj = [
                               r.unit_number,
                               r.volume,
                               r.weight
                           ];

                           columns.map((c)=>{
                               if(c.id !== undefined){
                                    var index = r.field_values.findIndex(item => 
                                        item.quality_field_id === c.id
                                    );

                                    if(index !== -1){
                                        obj.push(r.field_values[index].value);
                                    }else{
										obj.push('');
									}
                               }
                           });

                           return list.push(obj);
                        });

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
                            columns: columns,
							listado: list,
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Control de Calidad ->
					{this.state.filename}
					</h5>
				</div>
                <Help 
					{...this.props}
		            menu={"help_quality"} 
		            submenu={"help_quality_control"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
                                <div className="form-group">
									<span className="span-min">Tipo de Componente</span>
									<select type="text" name="component_type" id="component_type" 
										value={this.state.component_type} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										{this.state.components.map((h, i)=>{
											return <option key={i} value={h.key}>
												{h.name}
											</option>
										})}
									</select>
								</div>
                                {this.state.component_type !== 'all' ?
									<div className="form-group">
										<span className="span-min">Componente</span>
										<select type="text" name="blood_component_id" id="blood_component_id" 
											value={this.state.blood_component_id} onChange={this.handleChange}
											className="form-control" required>
											<option value="">Seleccione...</option>
											{this.state.blood_components.map((h, i)=>{
												return <option key={i} value={h.id}>
													{h.component}
												</option>
											})}
										</select>
									</div>
								: null}

                                <div className="form-group">
									<span className="span-min">Tipo consulta</span>
									<select className="form-control" name="type" id="type" 
										value={this.state.type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="date">Fecha</option>
										<option value="folio">Folio</option>
									</select>
								</div>

								{this.state.type === 'date' &&
                                    <div>
                                        <div className="form-group">
                                            <span className="span-min">Fecha Desde</span>
                                            <input type="date" className="form-control hour-input" name="start_date" id="start_date"
                                                value={this.state.start_date} onChange={this.handleChange} required />
                                        </div>
                                        <div className="form-group">
                                            <span className="span-min">Fecha Hasta</span>
                                            <input type="date" className="form-control hour-input" name="end_date" id="end_date"
                                                value={this.state.end_date} onChange={this.handleChange} required />
                                        </div>
                                    </div>
                                }
                                {this.state.type === 'folio' &&
                                    <div>
                                        <div className="form-group">
                                            <span className="span-min">Folio Inicial</span>
                                            <input className="form-control hour-input" name="folio_inicial" id="folio_inicial"
                                                value={this.state.folio_inicial} onChange={this.handleChange} required />
                                        </div>
                                        <div className="form-group">
                                            <span className="span-min">Folio Final</span>
                                            <input className="form-control hour-input" name="folio_final" id="folio_final"
                                                value={this.state.folio_final} onChange={this.handleChange} required />
                                        </div>
                                    </div>
                                }
                                
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>

								<div className="col-xs-12" style={{fontSize:'11px'}}>
									{this.state.component_type !== 'all' && this.state.component_type !== ""?
										<span>
											Tipo Componente:  
											<b style={{marginLeft:"5px"}}>{this.state.component_name}</b>
										</span>	
									:null}
									{this.state.blood_component_id !== 'all' && this.state.blood_component_id !== ""?
										<span style={{marginLeft:"10px"}}> 
											Componente:  
											<b style={{marginLeft:"5px"}}>{this.state.blood_component_name}</b>
										</span>	
									:null}
								</div>

								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (ComponentQuality);